import React, { createContext, useContext, ReactNode, useState, Dispatch, useMemo } from 'react'

import { useChangePreference } from 'contexts/bottomsheet-context/hooks/useChangePreference'
import { ChangeFinalidade, Purposes } from 'common/types'

import { UseMutationResult } from '@tanstack/react-query'

interface RequestConfirmationBottomSheetProviderBRProps {
  showDialog: boolean
  showSuccessStep: boolean
  changingFinalidade: ChangeFinalidade
  setShowDialog: Dispatch<React.SetStateAction<boolean>>
  setShowSuccessStep: Dispatch<React.SetStateAction<boolean>>
  setChangingFinalidade: Dispatch<React.SetStateAction<ChangeFinalidade>>
  mutation: UseMutationResult<Purposes, unknown, ChangeFinalidade, unknown>
}

interface RequestConfirmationBottomSheetContextBRProps {
  children: ReactNode
}

const RequestConfirmationBottomSheetContextBR =
  createContext<RequestConfirmationBottomSheetProviderBRProps>(
    {} as RequestConfirmationBottomSheetProviderBRProps,
  )

/**
 * Provider responsible for setting BR users new preferences (useSetPurposesBR)
 *
 * @param {RequestConfirmationBottomSheetContextBRProps}
 * @returns {RequestConfirmationBottomSheetContextBR.Provider}
 */
export const RequestConfirmationBottomSheetProviderBR = ({
  children,
}: RequestConfirmationBottomSheetContextBRProps) => {
  const [showDialog, setShowDialog] = useState(false)

  const [showSuccessStep, setShowSuccessStep] = useState(false)

  const [changingFinalidade, setChangingFinalidade] = useState<ChangeFinalidade>(
    {} as ChangeFinalidade,
  )

  const mutation = useChangePreference({
    onSuccess: () => setShowSuccessStep((prev) => !prev),
  })

  const value = useMemo(
    () => ({
      showDialog,
      setShowDialog,
      showSuccessStep,
      setShowSuccessStep,
      mutation,
      changingFinalidade,
      setChangingFinalidade,
    }),
    [
      showDialog,
      setShowDialog,
      showSuccessStep,
      setShowSuccessStep,
      mutation,
      changingFinalidade,
      setChangingFinalidade,
    ],
  )

  return (
    <RequestConfirmationBottomSheetContextBR.Provider value={value}>
      {children}
    </RequestConfirmationBottomSheetContextBR.Provider>
  )
}

export function useRequestConfirmationBottomSheetContextBR() {
  return useContext(RequestConfirmationBottomSheetContextBR)
}
